import React from "react";

const EmptyShareByMeProjectsIcon = () => (
  <svg width='148' height='148' viewBox='0 0 148 148' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle opacity='0.3' cx='74' cy='74' r='74' fill='url(#paint0_linear_3035_123106)' />
    <path
      d='M40 41.4336C40 37.1113 43.5039 33.6074 47.8262 33.6074H85.3267C87.79 33.6074 90.1096 34.7672 91.5876 36.7379L97.066 44.0423L103.772 51.2453C105.121 52.6937 105.87 54.5992 105.87 56.5782V106.652C105.87 110.974 102.367 114.478 98.0442 114.478H47.8262C43.5039 114.478 40 110.974 40 106.652V41.4336Z'
      fill='url(#paint1_linear_3035_123106)'
    />
    <path
      d='M85.6523 49.2611V35.4811C85.6523 33.7735 87.6865 32.8854 88.9389 34.0461L97.5378 42.0158C98.5235 42.9294 99.3925 43.9614 100.125 45.0883L105.536 53.4123C106.382 54.7139 105.448 56.4351 103.895 56.4351H92.8264C88.8643 56.4351 85.6523 53.2232 85.6523 49.2611Z'
      fill='#E1E1E1'
    />
    <path
      d='M50.8461 74.1404C50.8461 73.7644 50.9446 73.5002 51.1416 73.348C51.3386 73.1868 51.5804 73.1063 51.8669 73.1063C52.1534 73.1063 52.3952 73.1824 52.5922 73.3346C52.7981 73.4868 52.9011 73.7554 52.9011 74.1404C52.9011 74.5075 52.7981 74.7717 52.5922 74.9328C52.3952 75.094 52.1534 75.1746 51.8669 75.1746C51.5804 75.1746 51.3386 75.094 51.1416 74.9328C50.9446 74.7717 50.8461 74.5075 50.8461 74.1404ZM57.2432 75.1343C56.4015 75.1343 55.7166 74.8209 55.1883 74.1941C54.669 73.5584 54.4093 72.6183 54.4093 71.3737C54.4093 70.1291 54.6734 69.1889 55.2017 68.5532C55.73 67.9085 56.4239 67.5862 57.2835 67.5862C57.6417 67.5862 57.955 67.6354 58.2237 67.7339C58.5012 67.8235 58.7385 67.9488 58.9355 68.11C59.1325 68.2712 59.2981 68.4502 59.4324 68.6472H59.513C59.4862 68.5219 59.4593 68.3294 59.4324 68.0697C59.4056 67.81 59.3921 67.5683 59.3921 67.3444V64.7926H61.0844V75H59.7682L59.4593 74.0464H59.3921C59.2578 74.2434 59.0922 74.427 58.8952 74.5971C58.6982 74.7582 58.4654 74.8881 58.1968 74.9866C57.9282 75.0851 57.6103 75.1343 57.2432 75.1343ZM57.7536 73.7644C58.3804 73.7644 58.8236 73.5853 59.0832 73.2271C59.3429 72.869 59.4727 72.3273 59.4727 71.602V71.3871C59.4727 70.5992 59.3474 69.9993 59.0967 69.5874C58.8549 69.1755 58.3983 68.9696 57.7267 68.9696C57.2163 68.9696 56.8224 69.1844 56.5448 69.6142C56.2672 70.0351 56.1284 70.6305 56.1284 71.4005C56.1284 72.1706 56.2672 72.7571 56.5448 73.16C56.8224 73.5629 57.2253 73.7644 57.7536 73.7644ZM68.4039 71.8706C68.3591 71.7005 68.3054 71.4901 68.2427 71.2394C68.1801 70.9797 68.1129 70.7111 68.0413 70.4335C67.9786 70.1559 67.9159 69.9008 67.8533 69.668C67.7995 69.4352 67.7637 69.2561 67.7458 69.1307H67.6921C67.6652 69.2561 67.6249 69.4352 67.5712 69.668C67.5175 69.9008 67.4593 70.1559 67.3966 70.4335C67.3339 70.7111 67.2668 70.9797 67.1951 71.2394C67.1325 71.499 67.0787 71.7139 67.034 71.884L66.1878 75H64.3344L62.2929 67.7071H63.9986L64.8985 71.1856C64.9611 71.4184 65.0193 71.6826 65.0731 71.9781C65.1357 72.2735 65.1895 72.5601 65.2342 72.8376C65.279 73.1063 65.3103 73.3256 65.3283 73.4957H65.382C65.3999 73.3793 65.4223 73.2271 65.4491 73.0391C65.476 72.8421 65.5073 72.6407 65.5431 72.4347C65.5879 72.2198 65.6282 72.0228 65.664 71.8438C65.7088 71.6647 65.7446 71.5259 65.7715 71.4274L66.8191 67.7071H68.6725L69.6798 71.4274C69.7246 71.5886 69.7739 71.799 69.8276 72.0586C69.8813 72.3183 69.9306 72.578 69.9753 72.8376C70.0201 73.0973 70.047 73.3122 70.0559 73.4823H70.1096C70.1275 73.3301 70.1589 73.1242 70.2036 72.8645C70.2484 72.5959 70.3021 72.3094 70.3648 72.0049C70.4275 71.7005 70.4946 71.4274 70.5663 71.1856L71.4796 67.7071H73.1584L71.0901 75H69.2098L68.4039 71.8706ZM78.2229 67.5862C79.0735 67.5862 79.7585 67.904 80.2778 68.5398C80.7971 69.1665 81.0568 70.1022 81.0568 71.3468C81.0568 72.1706 80.9359 72.8645 80.6942 73.4286C80.4524 73.9927 80.1167 74.418 79.6869 74.7045C79.2571 74.991 78.7557 75.1343 78.1826 75.1343C77.8334 75.1343 77.5245 75.0895 77.2559 75C76.9873 74.9015 76.7589 74.7806 76.5709 74.6374C76.3829 74.4852 76.2217 74.324 76.0874 74.1539H75.98C76.0158 74.315 76.0426 74.4986 76.0605 74.7045C76.0784 74.9015 76.0874 75.0895 76.0874 75.2686V78.2234H74.3951V67.7205H75.7651L76.0068 68.6875H76.0874C76.2217 68.4816 76.3829 68.298 76.5709 68.1368C76.7679 67.9667 77.0007 67.8324 77.2693 67.7339C77.5469 67.6354 77.8647 67.5862 78.2229 67.5862ZM77.7394 68.9561C77.3454 68.9561 77.0276 69.0367 76.7858 69.1979C76.544 69.3501 76.3694 69.5874 76.262 69.9097C76.1546 70.2321 76.0964 70.635 76.0874 71.1185V71.3334C76.0874 71.8527 76.1366 72.2914 76.2351 72.6496C76.3426 73.0078 76.5172 73.2809 76.7589 73.4689C77.0097 73.6569 77.3454 73.7509 77.7663 73.7509C78.1244 73.7509 78.4154 73.6524 78.6393 73.4555C78.8721 73.2585 79.0422 72.9809 79.1496 72.6227C79.266 72.2556 79.3242 71.8214 79.3242 71.32C79.3242 70.5678 79.1944 69.9858 78.9347 69.5739C78.684 69.1621 78.2856 68.9561 77.7394 68.9561ZM86.6169 67.5862C86.7243 67.5862 86.8497 67.5907 86.9929 67.5996C87.1362 67.6086 87.2571 67.6265 87.3556 67.6533L87.2078 69.2247C87.1272 69.2068 87.0198 69.1934 86.8855 69.1844C86.7601 69.1665 86.6482 69.1576 86.5497 69.1576C86.2811 69.1576 86.0214 69.2024 85.7707 69.2919C85.529 69.3725 85.3096 69.4978 85.1126 69.668C84.9246 69.8291 84.7724 70.0395 84.656 70.2992C84.5485 70.5589 84.4948 70.8678 84.4948 71.2259V75H82.8025V67.7205H84.1053L84.347 68.983H84.4276C84.5709 68.7233 84.75 68.4905 84.9649 68.2846C85.1798 68.0697 85.426 67.8996 85.7036 67.7742C85.9901 67.6489 86.2945 67.5862 86.6169 67.5862ZM94.9429 71.3468C94.9429 71.9557 94.8623 72.4929 94.7012 72.9585C94.54 73.4241 94.3072 73.8226 94.0028 74.1539C93.7073 74.4762 93.3402 74.7224 92.9014 74.8926C92.4717 75.0537 91.9926 75.1343 91.4643 75.1343C90.9629 75.1343 90.5018 75.0537 90.081 74.8926C89.6601 74.7224 89.293 74.4762 88.9796 74.1539C88.6752 73.8226 88.4379 73.4241 88.2678 72.9585C88.0977 72.4929 88.0126 71.9557 88.0126 71.3468C88.0126 70.541 88.1514 69.8605 88.429 69.3053C88.7065 68.7412 89.105 68.3159 89.6243 68.0294C90.1526 67.7339 90.7749 67.5862 91.4912 67.5862C92.1717 67.5862 92.7671 67.7339 93.2775 68.0294C93.7968 68.3159 94.2042 68.7412 94.4997 69.3053C94.7952 69.8605 94.9429 70.541 94.9429 71.3468ZM89.7452 71.3468C89.7452 71.8572 89.8034 72.2959 89.9198 72.663C90.0452 73.0212 90.2332 73.2943 90.4839 73.4823C90.7436 73.6703 91.0748 73.7644 91.4778 73.7644C91.8897 73.7644 92.2209 73.6703 92.4717 73.4823C92.7313 73.2943 92.9193 73.0212 93.0358 72.663C93.1522 72.2959 93.2104 71.8572 93.2104 71.3468C93.2104 70.8275 93.1477 70.3932 93.0223 70.044C92.9059 69.6859 92.7179 69.4172 92.4582 69.2382C92.2075 69.0501 91.8807 68.9561 91.4778 68.9561C90.8689 68.9561 90.4257 69.1621 90.1481 69.5739C89.8795 69.9858 89.7452 70.5768 89.7452 71.3468Z'
      fill='black'
      fillOpacity='0.7'
    />
    <g filter='url(#filter0_ddd_3035_123106)'>
      <path
        d='M99.7041 109.764C99.7041 117.414 93.5023 118.174 85.8521 118.174C78.2018 118.174 72 117.414 72 109.764C72 102.114 78.2018 95.9121 85.8521 95.9121C93.5023 95.9121 99.7041 102.114 99.7041 109.764Z'
        fill='url(#paint2_linear_3035_123106)'
      />
      <circle cx='85.854' cy='88.3286' r='6.59622' fill='white' />
    </g>
    <g filter='url(#filter1_ddd_3035_123106)'>
      <path
        d='M117.98 110.539C117.98 119.145 111.003 120 102.396 120C93.7895 120 86.8125 119.145 86.8125 110.539C86.8125 101.932 93.7895 94.9551 102.396 94.9551C111.003 94.9551 117.98 101.932 117.98 110.539Z'
        fill='url(#paint3_linear_3035_123106)'
      />
      <circle cx='102.397' cy='86.4207' r='7.42075' fill='white' />
    </g>
    <circle opacity='0.3' cx='117.547' cy='104.547' r='9.54688' fill='#128370' />
    <path
      d='M118.67 103.61H123.137V105.763H118.67V110.276H116.494V105.763H112.051V103.61H116.494V99.0508H118.67V103.61Z'
      fill='white'
    />
    <defs>
      <filter
        id='filter0_ddd_3035_123106'
        x='59.1802'
        y='72.1175'
        width='53.3428'
        height='62.0811'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology radius='2.84885' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_3035_123106' />
        <feOffset dy='3.20496' />
        <feGaussianBlur stdDeviation='4.98549' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3035_123106' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='2.13664' />
        <feGaussianBlur stdDeviation='2.84885' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0' />
        <feBlend mode='normal' in2='effect1_dropShadow_3035_123106' result='effect2_dropShadow_3035_123106' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology radius='1.42443' operator='erode' in='SourceAlpha' result='effect3_dropShadow_3035_123106' />
        <feOffset dy='1.06832' />
        <feGaussianBlur stdDeviation='1.06832' />
        <feColorMatrix type='matrix' values='0 0 0 0 0.0705882 0 0 0 0 0.513726 0 0 0 0 0.439216 0 0 0 0.12 0' />
        <feBlend mode='normal' in2='effect2_dropShadow_3035_123106' result='effect3_dropShadow_3035_123106' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect3_dropShadow_3035_123106' result='shape' />
      </filter>
      <filter
        id='filter1_ddd_3035_123106'
        x='72.3902'
        y='68.1833'
        width='60.0126'
        height='69.8446'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology radius='3.20496' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_3035_123106' />
        <feOffset dy='3.60558' />
        <feGaussianBlur stdDeviation='5.60868' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3035_123106' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='2.40372' />
        <feGaussianBlur stdDeviation='3.20496' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0' />
        <feBlend mode='normal' in2='effect1_dropShadow_3035_123106' result='effect2_dropShadow_3035_123106' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology radius='1.60248' operator='erode' in='SourceAlpha' result='effect3_dropShadow_3035_123106' />
        <feOffset dy='1.20186' />
        <feGaussianBlur stdDeviation='1.20186' />
        <feColorMatrix type='matrix' values='0 0 0 0 0.0705882 0 0 0 0 0.513726 0 0 0 0 0.439216 0 0 0 0.12 0' />
        <feBlend mode='normal' in2='effect2_dropShadow_3035_123106' result='effect3_dropShadow_3035_123106' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect3_dropShadow_3035_123106' result='shape' />
      </filter>
      <linearGradient id='paint0_linear_3035_123106' x1='74' y1='0' x2='74' y2='148' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#6DD8CD' />
        <stop offset='1' stopColor='#E2F7F5' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_3035_123106'
        x1='72.9352'
        y1='33.6074'
        x2='72.9352'
        y2='114.478'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F8F8F8' />
        <stop offset='1' stopColor='#E1E1E1' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_3035_123106'
        x1='85.8521'
        y1='95.9121'
        x2='85.8521'
        y2='118.174'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F8F8F8' />
        <stop offset='1' stopColor='#E1E1E1' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_3035_123106'
        x1='102.396'
        y1='94.9551'
        x2='102.396'
        y2='120'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F8F8F8' />
        <stop offset='1' stopColor='#E1E1E1' />
      </linearGradient>
    </defs>
  </svg>
);
export default EmptyShareByMeProjectsIcon;
